import { useState, useEffect, useCallback } from "react";
import { FiSettings, FiTrash } from "react-icons/fi";
import styles from "../styles/PaymentMethods.module.css";
import CreatePaymentModal from "../pages/PaymentMethods/CreatePaymentModal";
import { API_URL } from "../config/api";

const PaymentMethods = () => {
  const [methods, setMethods] = useState([]);
  const [wallets, setWallets] = useState([]);
  const [showModal, setShowModal] = useState(false);

  const token = localStorage.getItem("token");

  useEffect(() => {
    const fetchWallets = async () => {
      if (!token) {
        console.error("Нет токена! Авторизация не выполнена.");
        return;
      }

      try {
        const res = await fetch(`${API_URL}/api/wallets`, {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        });

        const data = await res.json();

        if (Array.isArray(data.data)) {
          setWallets(data.data);
          localStorage.setItem("wallets", JSON.stringify(data.data));
        } else {
          console.warn("⚠️ Ожидался массив wallets, но пришло:", data);
        }
      } catch (err) {
        console.error("Ошибка при GET wallets:", err);

        const saved = localStorage.getItem("wallets");
        if (saved) setWallets(JSON.parse(saved));
      }
    };

    fetchWallets();
  }, [token]);

  const fetchMethods = useCallback(async () => {
    if (!token || wallets.length === 0) return;

    try {
      const res = await fetch(`${API_URL}/api/payment_methods`, {
        headers: { Authorization: `Bearer ${token}` },
      });

      const data = await res.json();

      if (Array.isArray(data.data)) {
        const mapped = data.data.map((item) => {
          const wallet = wallets.find((w) => w.id === item.wallet_id);

          return {
            id: item.id,
            name: item.title,
            pos: item.is_enabled ? "Да" : "Нет",
            wallet: wallet
              ? wallet.type === "card"
                ? wallet.bank_name
                : wallet.storage
              : "—",
            type: item.payment_type_id === 1 ? "Картой" : "Наличкой",
            status: item.is_enabled,
            is_primary: item.is_primary,
          };
        });

        setMethods(mapped);
      }
    } catch (err) {
      console.error(err);
    }
  }, [token, wallets]);

  useEffect(() => {
    fetchMethods();
  }, [fetchMethods]);

  const deleteMethod = async (id) => {
    if (!token) {
      console.error("Нет токена! Авторизация не выполнена.");
      return;
    }

    try {
      const res = await fetch(`${API_URL}/api/payment_methods/${id}`, {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });

      if (res.ok) {
        setMethods((prev) => prev.filter((method) => method.id !== id));
        console.log(`Метод оплаты ${id} успешно удален`);
      } else {
        const errorData = await res.json();
        console.error("Ошибка при удалении:", errorData);
      }
    } catch (err) {
      console.error("Ошибка при DELETE запросе:", err);
    }
  };

  const toggleStatus = (index) => {
    const updated = [...methods];
    updated[index].status = !updated[index].status;
    setMethods(updated);
  };

  return (
    <div className={styles.container}>
      <h2 className={styles.title}>Способы оплаты</h2>
      <button className={styles.add} onClick={() => setShowModal(true)}>
        +
      </button>

      <div className={styles.tableWrapper}>
        <table className={styles.table}>
          <thead>
            <tr>
              <th>Название</th>
              <th>POS терминал</th>
              <th>Кошелёк</th>
              <th>Тип</th>
              <th>Статус</th>
              <th>
                <FiSettings size={18} />
              </th>
            </tr>
          </thead>
          <tbody>
            {methods.map((method, index) => (
              <tr key={method.id || index}>
                <td>{method.name}</td>
                <td>{method.pos}</td>
                <td>{method.wallet}</td>
                <td>{method.type}</td>
                <td>
                  <label className={styles.toggle}>
                    <input
                      type="checkbox"
                      checked={method.status}
                      onChange={() => toggleStatus(index)}
                    />
                    <span className={styles.slider}></span>
                  </label>
                </td>
                <td>
                  <button
                    className={styles.settingsBtn}
                    onClick={() => deleteMethod(method.id)}
                  >
                    <FiTrash size={20} />
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {showModal && (
        <CreatePaymentModal
          onClose={() => setShowModal(false)}
          onSave={fetchMethods}
        />
      )}
    </div>
  );
};

export default PaymentMethods;
